"use strict";
(self["__LOADABLE_LOADED_CHUNKS__"] = self["__LOADABLE_LOADED_CHUNKS__"] || []).push([[9410,6321],{

/***/ 10698:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   Z: () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(97458);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(52983);
/* harmony import */ var links__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(69541);
/* harmony import */ var cookie_storage__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(83913);
/* harmony import */ var helpers__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(50556);
/* harmony import */ var analytics__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(66226);
/* harmony import */ var modules_subscription__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(91339);
/* harmony import */ var components_dataDisplay__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(1041);








var LogoLink = function(props) {
    var className = props.className, customLink = props.to, color = props.color;
    var subscription = (0,modules_subscription__WEBPACK_IMPORTED_MODULE_2__/* .useSubscription */ .m)().subscription;
    var defaultLink = (subscription === null || subscription === void 0 ? void 0 : subscription.hasNeverSubscribed) === false ? links__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .ZP.subscription.main : cookie_storage__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .ZP.getItem(helpers__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z.cookieNames.logoRedirectUrl) || links__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .ZP.home;
    var to = customLink === undefined ? defaultLink : customLink;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_dataDisplay__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
        className: className,
        to: to,
        color: color,
        onClick: function() {
            (0,analytics__WEBPACK_IMPORTED_MODULE_7__/* .track */ .j)("Scentbird logo click");
        }
    });
};
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (LogoLink);


/***/ }),

/***/ 80348:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   Z: () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* unused harmony export keyToIconNameMap */
/* harmony import */ var core_js_modules_es_array_slice_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(43474);
/* harmony import */ var core_js_modules_es_array_slice_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_slice_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_array_map_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(72463);
/* harmony import */ var core_js_modules_es_array_map_js__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_map_js__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(97458);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(52983);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(78364);
/* harmony import */ var components_dataDisplay__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(24959);






var keyToIconNameMap = {
    BESTSELLER: "48/bestseller",
    CHARITY: "48/charity",
    CLEAN: "48/clean",
    LIMITED_EDITION: "48/limited-time",
    NEW_ARRIVAL: "48/new",
    SOLD_OUT: "48/out-of-stock"
};
var ProductGraphicLabels = function(props) {
    var className = props.className, items = props.items, limit = props.limit;
    if (!(items === null || items === void 0 ? void 0 : items.length)) {
        return null;
    }
    if (limit && items.length > limit) {
        items = items.slice(0, limit);
    }
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("div", {
        className: (0,classnames__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(className, "grid grid-cols-1 gap-16"),
        children: items.map(function(key) {
            return Boolean(keyToIconNameMap[key]) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(components_dataDisplay__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .ZP, {
                className: "mx-auto",
                name: keyToIconNameMap[key],
                "aria-label": key
            }, key);
        })
    });
};
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (/*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_3__.memo(ProductGraphicLabels));


/***/ }),

/***/ 82775:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  Z: () => (/* binding */ ProductPrice_ProductPrice)
});

// EXTERNAL MODULE: ../../node_modules/.pnpm/react@18.2.0/node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(97458);
// EXTERNAL MODULE: ../../node_modules/.pnpm/react@18.2.0/node_modules/react/index.js
var react = __webpack_require__(52983);
// EXTERNAL MODULE: ../../node_modules/.pnpm/clsx@2.1.0/node_modules/clsx/dist/clsx.mjs
var clsx = __webpack_require__(78364);
// EXTERNAL MODULE: ./local_modules/intl/useIntl.ts
var useIntl = __webpack_require__(56376);
// EXTERNAL MODULE: ./src/helpers/modifiers/formatPrice.ts
var formatPrice = __webpack_require__(72160);
// EXTERNAL MODULE: ./src/components/dataDisplay/Text/Text.tsx + 1 modules
var Text = __webpack_require__(31627);
;// CONCATENATED MODULE: ./src/compositions/ProductPrice/messages.ts
/* harmony default export */ const messages = ({
    old: {
        en: "Price reduced from"
    },
    "new": {
        en: "On sale at"
    }
});

;// CONCATENATED MODULE: ./src/compositions/ProductPrice/ProductPrice.tsx







// TODO should we use currencyCode from data? - added on 14.01.2022 by sonatskiy
var ProductPrice = function(props) {
    var _data_discountPrice, _data_standardPrice;
    var className = props.className, data = props.data, formattedData = props.formattedData, _props_textStyle = props.textStyle, textStyle = _props_textStyle === void 0 ? "h8" : _props_textStyle, _props_oldPriceClassName = props.oldPriceClassName, oldPriceClassName = _props_oldPriceClassName === void 0 ? "font-normal" : _props_oldPriceClassName, _props_newPriceClassName = props.newPriceClassName, newPriceClassName = _props_newPriceClassName === void 0 ? "font-bold" : _props_newPriceClassName, _props_withNbsp = props.withNbsp, withNbsp = _props_withNbsp === void 0 ? true : _props_withNbsp;
    var intl = (0,useIntl/* default */.Z)();
    var discountPrice = data === null || data === void 0 ? void 0 : (_data_discountPrice = data.discountPrice) === null || _data_discountPrice === void 0 ? void 0 : _data_discountPrice.amount;
    var standardPrice = data === null || data === void 0 ? void 0 : (_data_standardPrice = data.standardPrice) === null || _data_standardPrice === void 0 ? void 0 : _data_standardPrice.amount;
    var finalPrice;
    var oldPrice;
    var oldPriceLabel;
    var newPriceLabel;
    if (formattedData) {
        var discountPrice1 = formattedData.discountPrice, standardPrice1 = formattedData.standardPrice;
        finalPrice = discountPrice1 || standardPrice1;
        if (finalPrice !== standardPrice1) {
            oldPrice = standardPrice1;
            oldPriceLabel = intl.formatMessage(messages.old);
            newPriceLabel = intl.formatMessage(messages["new"]);
        }
    } else {
        if (typeof discountPrice === "number") {
            // it's formatted as USD, not cents
            finalPrice = (0,formatPrice/* default */.Z)(discountPrice, {
                isCents: false
            });
            if (standardPrice > discountPrice) {
                oldPrice = (0,formatPrice/* default */.Z)(standardPrice, {
                    isCents: false
                });
                oldPriceLabel = intl.formatMessage(messages.old);
                newPriceLabel = intl.formatMessage(messages["new"]);
            }
        } else if (typeof standardPrice === "number") {
            finalPrice = (0,formatPrice/* default */.Z)(standardPrice, {
                isCents: false
            });
        }
    }
    if (!finalPrice) {
        return null;
    }
    if (oldPrice) {
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Text/* default */.ZP, {
            className: className,
            style: textStyle,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("s", {
                    className: (0,clsx/* default */.Z)(oldPriceClassName),
                    "aria-label": oldPriceLabel,
                    "data-testid": "oldPrice",
                    children: oldPrice
                }),
                withNbsp && "\xa0",
                /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                    className: (0,clsx/* default */.Z)(newPriceClassName),
                    "aria-label": newPriceLabel,
                    "data-testid": "price",
                    children: finalPrice
                })
            ]
        });
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.ZP, {
        className: (0,clsx/* default */.Z)(className, newPriceClassName),
        style: textStyle,
        "data-testid": "price",
        children: finalPrice
    });
};
/* harmony default export */ const ProductPrice_ProductPrice = (/*#__PURE__*/react.memo(ProductPrice));


/***/ }),

/***/ 76133:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   Z: () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var core_js_modules_es_array_concat_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(35570);
/* harmony import */ var core_js_modules_es_array_concat_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_concat_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(97458);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(52983);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(78364);
/* harmony import */ var analytics__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(66226);
/* harmony import */ var intl__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(17696);
/* harmony import */ var components_dataDisplay__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(26713);
/* harmony import */ var components_dataDisplay__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(85808);
/* harmony import */ var components_dataDisplay__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(31627);
/* harmony import */ var components_inputs__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(23796);
/* harmony import */ var components_navigation__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(73358);
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}









var BannerBase = function(props) {
    var tmp = props["data-testid"], dataTestId = tmp === void 0 ? "banner" : tmp, bgImage = props.bgImage, buttonStyle = props.buttonStyle, buttonTitle = props.buttonTitle, content = props.content, logo = props.logo, logoClassName = props.logoClassName, onClick = props.onClick, text = props.text, textColor = props.textColor, title = props.title, titleClassName = props.titleClassName, titleColor = props.titleColor, to = props.to, toTab = props.toTab, href = props.href, _props_placement = props.placement, placement = _props_placement === void 0 ? "Desktop navigation menu" : _props_placement, _props_trackParams = props.trackParams, trackParams = _props_trackParams === void 0 ? {} : _props_trackParams, caption = props.caption, _props_height = props.height, height = _props_height === void 0 ? 296 : _props_height;
    var handleClick = function() {
        (0,analytics__WEBPACK_IMPORTED_MODULE_3__/* .track */ .j)("Banner click", _object_spread({
            placement: placement,
            content: content,
            link: to,
            action: "link"
        }, trackParams));
        if (typeof onClick === "function") {
            onClick();
        }
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(components_navigation__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
        to: to,
        href: href,
        toTab: toTab,
        onClick: handleClick,
        "data-testid": dataTestId,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(components_dataDisplay__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
            className: "flex flex-col items-start justify-center bg-gray-70 p-32",
            src: bgImage,
            quality: 90,
            style: {
                backgroundPosition: "0 50%",
                height: "".concat(height, "rem")
            },
            children: [
                Boolean(logo) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(components_dataDisplay__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                    className: logoClassName,
                    src: logo
                }),
                Boolean(title) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(components_dataDisplay__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .ZP, {
                    className: (0,classnames__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)("whitespace-pre-line", titleClassName),
                    style: "h7",
                    color: titleColor,
                    message: title,
                    html: true
                }),
                Boolean(text) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(components_dataDisplay__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .ZP, {
                    className: "mt-16 whitespace-pre-line",
                    style: "p3",
                    color: textColor,
                    message: text,
                    html: true
                }),
                Boolean(buttonTitle) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(components_inputs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z, {
                    className: "mt-16",
                    title: buttonTitle,
                    size: 48,
                    style: buttonStyle,
                    tabIndex: -1,
                    width: 240
                }),
                Boolean(caption) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("figcaption", {
                    className: "visually-hidden",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(intl__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z, {
                        value: caption
                    })
                })
            ]
        })
    });
};
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (BannerBase);


/***/ }),

/***/ 47866:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  Z: () => (/* binding */ TheEditBanner_TheEditBanner)
});

// EXTERNAL MODULE: ../../node_modules/.pnpm/react@18.2.0/node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(97458);
// EXTERNAL MODULE: ../../node_modules/.pnpm/react@18.2.0/node_modules/react/index.js
var react = __webpack_require__(52983);
// EXTERNAL MODULE: ./local_modules/links/index.ts + 4 modules
var links = __webpack_require__(69541);
// EXTERNAL MODULE: ./src/components/inputs/Button/messages.ts
var messages = __webpack_require__(21182);
// EXTERNAL MODULE: ./src/compositions/banners/BannerBase/BannerBase.tsx
var BannerBase = __webpack_require__(76133);
;// CONCATENATED MODULE: ./src/compositions/banners/TheEditBanner/images/bg.jpg
const bg_namespaceObject = __webpack_require__.p + "images/bg_cbfdf7.jpg";
;// CONCATENATED MODULE: ./src/compositions/banners/TheEditBanner/messages.ts
/* harmony default export */ const TheEditBanner_messages = ({
    title: {
        en: "Shop the Edit"
    },
    text: {
        en: "\n      Immerse yourself in scent<br />\n      beyond the bottle with<br />\n      candles, body lotions,<br />\n      diffusers, and so much more.\n    "
    }
});

;// CONCATENATED MODULE: ./src/compositions/banners/TheEditBanner/TheEditBanner.tsx







var TheEditBanner = function(props) {
    var onClick = props.onClick, tmp = props["data-testid"], dataTestId = tmp === void 0 ? "theEditBanner" : tmp, placement = props.placement;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(BannerBase/* default */.Z, {
        to: links/* default */.ZP.shop.theEdit,
        title: TheEditBanner_messages.title,
        text: TheEditBanner_messages.text,
        textColor: "black",
        bgImage: bg_namespaceObject,
        buttonTitle: messages/* default */.Z.learnMore,
        content: "TheEdit",
        onClick: onClick,
        placement: placement,
        "data-testid": dataTestId
    });
};
/* harmony default export */ const TheEditBanner_TheEditBanner = (TheEditBanner);


/***/ }),

/***/ 48106:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   Z: () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(97458);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(52983);
/* harmony import */ var analytics__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(66226);
/* harmony import */ var modals__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(31978);
/* harmony import */ var helpers__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(72160);
/* harmony import */ var components_inputs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(23796);
/* harmony import */ var components_inputs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(21182);
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}






var CandleClubSubscribeButton = function(props) {
    var className = props.className, title = props.title, price = props.price, placement = props.placement, _props_size = props.size, size = _props_size === void 0 ? 56 : _props_size, _props_style = props.style, style = _props_style === void 0 ? "primary" : _props_style, width = props.width, fullWidth = props.fullWidth, fullWidthOnMobile = props.fullWidthOnMobile, tmp = props["data-testid"], dataTestId = tmp === void 0 ? "candleSubscriptionButton" : tmp;
    var handleSubscribeClick = function() {
        (0,analytics__WEBPACK_IMPORTED_MODULE_2__/* .track */ .j)("Banner click", {
            placement: placement,
            content: "Candle subscription",
            action: "Subscribe"
        });
        (0,modals__WEBPACK_IMPORTED_MODULE_3__/* .openModal */ .h7)("candleSubscriptionConfirmationModal", {
            action: "subscribe"
        });
    };
    var handleMouseOver = function() {
        void (0,modals__WEBPACK_IMPORTED_MODULE_3__/* .preloadModal */ .My)("candleSubscriptionConfirmationModal");
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_inputs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
        className: className,
        title: title || _object_spread_props(_object_spread({}, components_inputs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z.subscribeForPrice), {
            values: {
                price: (0,helpers__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(price || 2500)
            }
        }),
        size: size,
        style: style,
        width: width,
        fullWidth: fullWidth,
        fullWidthOnMobile: fullWidthOnMobile,
        onClick: handleSubscribeClick,
        onMouseOver: handleMouseOver,
        "data-testid": dataTestId
    });
};
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (CandleClubSubscribeButton);


/***/ }),

/***/ 89525:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": () => (/* binding */ SearchModal_SearchModal)
});

// EXTERNAL MODULE: ../../node_modules/.pnpm/core-js@3.35.0/node_modules/core-js/modules/es.function.name.js
var es_function_name = __webpack_require__(28950);
// EXTERNAL MODULE: ../../node_modules/.pnpm/core-js@3.35.0/node_modules/core-js/modules/es.string.search.js
var es_string_search = __webpack_require__(81738);
// EXTERNAL MODULE: ../../node_modules/.pnpm/core-js@3.35.0/node_modules/core-js/modules/es.regexp.exec.js
var es_regexp_exec = __webpack_require__(17376);
// EXTERNAL MODULE: ../../node_modules/.pnpm/react@18.2.0/node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(97458);
// EXTERNAL MODULE: ../../node_modules/.pnpm/react@18.2.0/node_modules/react/index.js
var react = __webpack_require__(52983);
// EXTERNAL MODULE: ../../node_modules/.pnpm/clsx@2.1.0/node_modules/clsx/dist/clsx.mjs
var clsx = __webpack_require__(78364);
// EXTERNAL MODULE: ./src/hooks/useFt.ts
var useFt = __webpack_require__(68426);
// EXTERNAL MODULE: ./local_modules/device/useDevice.ts
var useDevice = __webpack_require__(47361);
// EXTERNAL MODULE: ./src/helpers/constants/index.ts + 8 modules
var constants = __webpack_require__(50556);
// EXTERNAL MODULE: ./src/components/dataDisplay/Text/Text.tsx + 1 modules
var Text = __webpack_require__(31627);
// EXTERNAL MODULE: ./src/components/layout/WidthContainer/WidthContainer.tsx
var WidthContainer = __webpack_require__(24113);
// EXTERNAL MODULE: ./src/components/feedback/PlainModal/PlainModal.tsx + 1 modules
var PlainModal = __webpack_require__(87586);
// EXTERNAL MODULE: ./src/components/inputs/SearchInput/SearchInput.tsx + 1 modules
var SearchInput = __webpack_require__(64652);
// EXTERNAL MODULE: ./src/components/inputs/CloseIconButton/CloseIconButton.tsx + 2 modules
var CloseIconButton = __webpack_require__(19770);
// EXTERNAL MODULE: ./src/compositions/LogoLink/LogoLink.tsx
var LogoLink = __webpack_require__(10698);
// EXTERNAL MODULE: ./local_modules/formular/useForm.ts
var useForm = __webpack_require__(7289);
// EXTERNAL MODULE: ./local_modules/throttle-debounce/debounce.ts
var debounce = __webpack_require__(65163);
// EXTERNAL MODULE: ./local_modules/apollo-client/hooks/useLazyQuery.ts + 1 modules
var useLazyQuery = __webpack_require__(15151);
// EXTERNAL MODULE: ../../node_modules/.pnpm/core-js@3.35.0/node_modules/core-js/modules/es.set.js
var es_set = __webpack_require__(41964);
// EXTERNAL MODULE: ../../node_modules/.pnpm/core-js@3.35.0/node_modules/core-js/modules/es.array.iterator.js
var es_array_iterator = __webpack_require__(5119);
// EXTERNAL MODULE: ../../node_modules/.pnpm/core-js@3.35.0/node_modules/core-js/modules/web.dom-collections.iterator.js
var web_dom_collections_iterator = __webpack_require__(94218);
// EXTERNAL MODULE: ../../node_modules/.pnpm/core-js@3.35.0/node_modules/core-js/modules/es.string.iterator.js
var es_string_iterator = __webpack_require__(40045);
// EXTERNAL MODULE: ../../node_modules/.pnpm/core-js@3.35.0/node_modules/core-js/modules/es.object.to-string.js
var es_object_to_string = __webpack_require__(51497);
;// CONCATENATED MODULE: ./src/compositions/modals/SearchModal/util/productSearch.graphql.ts
function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_without_holes(arr) {
    if (Array.isArray(arr)) return _array_like_to_array(arr);
}
function _iterable_to_array(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _non_iterable_spread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _to_consumable_array(arr) {
    return _array_without_holes(arr) || _iterable_to_array(arr) || _unsupported_iterable_to_array(arr) || _non_iterable_spread();
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}





var ProductSearchDocument = {
    kind: "Document",
    definitions: [
        {
            kind: "OperationDefinition",
            operation: "query",
            name: {
                kind: "Name",
                value: "ProductSearch"
            },
            variableDefinitions: [
                {
                    kind: "VariableDefinition",
                    variable: {
                        kind: "Variable",
                        name: {
                            kind: "Name",
                            value: "input"
                        }
                    },
                    type: {
                        kind: "NonNullType",
                        type: {
                            kind: "NamedType",
                            name: {
                                kind: "Name",
                                value: "ProductSearchInput"
                            }
                        }
                    }
                }
            ],
            selectionSet: {
                kind: "SelectionSet",
                selections: [
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "productSearch"
                        },
                        "arguments": [
                            {
                                kind: "Argument",
                                name: {
                                    kind: "Name",
                                    value: "input"
                                },
                                value: {
                                    kind: "Variable",
                                    name: {
                                        kind: "Name",
                                        value: "input"
                                    }
                                }
                            }
                        ],
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "products"
                                    },
                                    selectionSet: {
                                        kind: "SelectionSet",
                                        selections: [
                                            {
                                                kind: "FragmentSpread",
                                                name: {
                                                    kind: "Name",
                                                    value: "ProductDrift"
                                                }
                                            }
                                        ]
                                    }
                                }
                            ]
                        }
                    }
                ]
            }
        },
        {
            kind: "FragmentDefinition",
            name: {
                kind: "Name",
                value: "TradingItemBase"
            },
            typeCondition: {
                kind: "NamedType",
                name: {
                    kind: "Name",
                    value: "TradingItem"
                }
            },
            selectionSet: {
                kind: "SelectionSet",
                selections: [
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "id"
                        }
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "section"
                        }
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "productGroup"
                        }
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "image"
                        }
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "inStock"
                        }
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "type"
                        }
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "isLimitedEdition"
                        }
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "volume"
                        },
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "unit"
                                    }
                                },
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "volume"
                                    }
                                }
                            ]
                        }
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "prices"
                        },
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "standardPrice"
                                    },
                                    selectionSet: {
                                        kind: "SelectionSet",
                                        selections: [
                                            {
                                                kind: "Field",
                                                name: {
                                                    kind: "Name",
                                                    value: "amount"
                                                }
                                            },
                                            {
                                                kind: "Field",
                                                name: {
                                                    kind: "Name",
                                                    value: "amountCents"
                                                }
                                            },
                                            {
                                                kind: "Field",
                                                name: {
                                                    kind: "Name",
                                                    value: "currencyCode"
                                                }
                                            }
                                        ]
                                    }
                                },
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "discountPrice"
                                    },
                                    selectionSet: {
                                        kind: "SelectionSet",
                                        selections: [
                                            {
                                                kind: "Field",
                                                name: {
                                                    kind: "Name",
                                                    value: "amount"
                                                }
                                            },
                                            {
                                                kind: "Field",
                                                name: {
                                                    kind: "Name",
                                                    value: "amountCents"
                                                }
                                            },
                                            {
                                                kind: "Field",
                                                name: {
                                                    kind: "Name",
                                                    value: "currencyCode"
                                                }
                                            }
                                        ]
                                    }
                                }
                            ]
                        }
                    }
                ]
            }
        },
        {
            kind: "FragmentDefinition",
            name: {
                kind: "Name",
                value: "ProductBase"
            },
            typeCondition: {
                kind: "NamedType",
                name: {
                    kind: "Name",
                    value: "Product"
                }
            },
            selectionSet: {
                kind: "SelectionSet",
                selections: [
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "id"
                        }
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "url"
                        }
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "fullName"
                        }
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "name"
                        }
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "type"
                        }
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "brandInfo"
                        },
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "name"
                                    }
                                }
                            ]
                        }
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "image"
                        }
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "rebrandImage"
                        }
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "gender"
                        }
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "theEdit"
                        }
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "rebrandLabels"
                        },
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "marketing"
                                    }
                                },
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "extra"
                                    }
                                },
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "characteristic"
                                    }
                                }
                            ]
                        }
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "category"
                        }
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "typeGroup"
                        }
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "upchargePrice"
                        }
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "hasLep"
                        }
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "hasVariety"
                        }
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "isSubscribedToStockNotification"
                        }
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "rating"
                        },
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "avgRate"
                                    }
                                }
                            ]
                        }
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "selectedTradingItem"
                        }
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "tradingItems"
                        },
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "items"
                                    },
                                    selectionSet: {
                                        kind: "SelectionSet",
                                        selections: [
                                            {
                                                kind: "FragmentSpread",
                                                name: {
                                                    kind: "Name",
                                                    value: "TradingItemBase"
                                                }
                                            }
                                        ]
                                    }
                                }
                            ]
                        }
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "shareEmailAgreement"
                        },
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [
                                {
                                    kind: "Field",
                                    alias: {
                                        kind: "Name",
                                        value: "exceptMobileBanner"
                                    },
                                    name: {
                                        kind: "Name",
                                        value: "banner"
                                    },
                                    "arguments": [
                                        {
                                            kind: "Argument",
                                            name: {
                                                kind: "Name",
                                                value: "type"
                                            },
                                            value: {
                                                kind: "EnumValue",
                                                value: "DESKTOP"
                                            }
                                        }
                                    ]
                                },
                                {
                                    kind: "Field",
                                    alias: {
                                        kind: "Name",
                                        value: "mobileBanner"
                                    },
                                    name: {
                                        kind: "Name",
                                        value: "banner"
                                    },
                                    "arguments": [
                                        {
                                            kind: "Argument",
                                            name: {
                                                kind: "Name",
                                                value: "type"
                                            },
                                            value: {
                                                kind: "EnumValue",
                                                value: "MOBILE"
                                            }
                                        }
                                    ]
                                },
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "title"
                                    }
                                },
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "description"
                                    }
                                },
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "advantages"
                                    }
                                },
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "agreement"
                                    }
                                },
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "note"
                                    }
                                }
                            ]
                        }
                    }
                ]
            }
        },
        {
            kind: "FragmentDefinition",
            name: {
                kind: "Name",
                value: "ProductDetailed"
            },
            typeCondition: {
                kind: "NamedType",
                name: {
                    kind: "Name",
                    value: "Product"
                }
            },
            selectionSet: {
                kind: "SelectionSet",
                selections: [
                    {
                        kind: "FragmentSpread",
                        name: {
                            kind: "Name",
                            value: "ProductBase"
                        }
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "notes"
                        },
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "id"
                                    }
                                },
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "name"
                                    }
                                },
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "image"
                                    }
                                },
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "rebrandImage"
                                    }
                                }
                            ]
                        }
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "description"
                        }
                    }
                ]
            }
        },
        {
            kind: "FragmentDefinition",
            name: {
                kind: "Name",
                value: "TradingItemDrift"
            },
            typeCondition: {
                kind: "NamedType",
                name: {
                    kind: "Name",
                    value: "TradingItem"
                }
            },
            selectionSet: {
                kind: "SelectionSet",
                selections: [
                    {
                        kind: "FragmentSpread",
                        name: {
                            kind: "Name",
                            value: "TradingItemBase"
                        }
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "variety"
                        },
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "name"
                                    }
                                },
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "image"
                                    }
                                },
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "description"
                                    }
                                }
                            ]
                        }
                    }
                ]
            }
        },
        {
            kind: "FragmentDefinition",
            name: {
                kind: "Name",
                value: "ProductDrift"
            },
            typeCondition: {
                kind: "NamedType",
                name: {
                    kind: "Name",
                    value: "Product"
                }
            },
            selectionSet: {
                kind: "SelectionSet",
                selections: [
                    {
                        kind: "FragmentSpread",
                        name: {
                            kind: "Name",
                            value: "ProductDetailed"
                        }
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "tradingItems"
                        },
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "items"
                                    },
                                    selectionSet: {
                                        kind: "SelectionSet",
                                        selections: [
                                            {
                                                kind: "FragmentSpread",
                                                name: {
                                                    kind: "Name",
                                                    value: "TradingItemDrift"
                                                }
                                            }
                                        ]
                                    }
                                }
                            ]
                        }
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "drift"
                        },
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "name"
                                    }
                                },
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "image"
                                    }
                                },
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "description"
                                    }
                                },
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "starterSet"
                                    }
                                },
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "price"
                                    },
                                    selectionSet: {
                                        kind: "SelectionSet",
                                        selections: [
                                            {
                                                kind: "Field",
                                                name: {
                                                    kind: "Name",
                                                    value: "amount"
                                                }
                                            },
                                            {
                                                kind: "Field",
                                                name: {
                                                    kind: "Name",
                                                    value: "amountCents"
                                                }
                                            },
                                            {
                                                kind: "Field",
                                                name: {
                                                    kind: "Name",
                                                    value: "currencyCode"
                                                }
                                            }
                                        ]
                                    }
                                },
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "discountPrice"
                                    },
                                    selectionSet: {
                                        kind: "SelectionSet",
                                        selections: [
                                            {
                                                kind: "Field",
                                                name: {
                                                    kind: "Name",
                                                    value: "amount"
                                                }
                                            },
                                            {
                                                kind: "Field",
                                                name: {
                                                    kind: "Name",
                                                    value: "amountCents"
                                                }
                                            },
                                            {
                                                kind: "Field",
                                                name: {
                                                    kind: "Name",
                                                    value: "currencyCode"
                                                }
                                            }
                                        ]
                                    }
                                }
                            ]
                        }
                    }
                ]
            }
        }
    ]
};
// remove fragments duplicates
// @ts-ignore
ProductSearchDocument["definitions"] = _to_consumable_array(new Set(ProductSearchDocument.definitions));
/* harmony default export */ const productSearch_graphql = (ProductSearchDocument);

;// CONCATENATED MODULE: ./src/compositions/modals/SearchModal/util/useSearchModal.ts
function useSearchModal_array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_with_holes(arr) {
    if (Array.isArray(arr)) return arr;
}
function _iterable_to_array_limit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _non_iterable_rest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _sliced_to_array(arr, i) {
    return _array_with_holes(arr) || _iterable_to_array_limit(arr, i) || useSearchModal_unsupported_iterable_to_array(arr, i) || _non_iterable_rest();
}
function useSearchModal_unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return useSearchModal_array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return useSearchModal_array_like_to_array(o, minLen);
}







var useSearchModal = function() {
    var _data_productSearch;
    var form = (0,useForm/* default */.Z)({
        fields: {
            search: []
        }
    });
    var _useLazyQuery = _sliced_to_array((0,useLazyQuery/* default */.Z)(productSearch_graphql), 2), executeSearch = _useLazyQuery[0], _useLazyQuery_ = _useLazyQuery[1], data = _useLazyQuery_.data, isFetching = _useLazyQuery_.isFetching, error = _useLazyQuery_.error;
    (0,react.useEffect)(function() {
        var handleQueryChange = (0,debounce/* default */.Z)(function() {
            var _form_getValues = form.getValues(), query = _form_getValues.search;
            executeSearch({
                variables: {
                    input: {
                        query: query,
                        pagination: {
                            limit: 10,
                            offset: 0
                        }
                    }
                }
            });
        }, 400);
        form.on("change", handleQueryChange);
        return function() {
            handleQueryChange.cancel();
            form.off("change", handleQueryChange);
        };
    }, [
        form,
        executeSearch
    ]);
    return {
        form: form,
        error: error,
        isFetching: isFetching,
        query: form.fields.search.state.value,
        products: (data === null || data === void 0 ? void 0 : (_data_productSearch = data.productSearch) === null || _data_productSearch === void 0 ? void 0 : _data_productSearch.products) || []
    };
};

// EXTERNAL MODULE: ../../node_modules/.pnpm/core-js@3.35.0/node_modules/core-js/modules/es.array.slice.js
var es_array_slice = __webpack_require__(43474);
// EXTERNAL MODULE: ./src/modules/user/user/index.tsx + 1 modules
var user = __webpack_require__(17382);
// EXTERNAL MODULE: ./src/modules/subscription/subscriptionAddons/index.ts + 5 modules
var subscriptionAddons = __webpack_require__(4833);
;// CONCATENATED MODULE: ./src/compositions/modals/SearchModal/messages.ts
/* harmony default export */ const messages = ({
    placeholder: {
        en: "Search Scentbird..."
    },
    topRatedTitle: {
        en: "Perfumes that we love"
    },
    notFound: {
        en: "Sorry, we couldn’t find what you were searching for. Try browsing our best sellers..."
    },
    somethingWrong: {
        en: "Something went wrong, please try again later"
    }
});

// EXTERNAL MODULE: ../../node_modules/.pnpm/core-js@3.35.0/node_modules/core-js/modules/es.array.fill.js
var es_array_fill = __webpack_require__(4130);
// EXTERNAL MODULE: ../../node_modules/.pnpm/core-js@3.35.0/node_modules/core-js/modules/es.array.map.js
var es_array_map = __webpack_require__(72463);
// EXTERNAL MODULE: ../../node_modules/.pnpm/core-js@3.35.0/node_modules/core-js/modules/es.array.concat.js
var es_array_concat = __webpack_require__(35570);
// EXTERNAL MODULE: ./local_modules/analytics/index.ts
var analytics = __webpack_require__(66226);
// EXTERNAL MODULE: ./src/components/layout/Grid/Grid.tsx + 1 modules
var Grid = __webpack_require__(53285);
// EXTERNAL MODULE: ./src/compositions/productCards/ProductCardSmall/ProductCardSmall.tsx
var ProductCardSmall = __webpack_require__(80759);
// EXTERNAL MODULE: ./src/compositions/productCards/ProductCardSmallSkeleton/ProductCardSmallSkeleton.tsx
var ProductCardSmallSkeleton = __webpack_require__(73095);
;// CONCATENATED MODULE: ./src/compositions/modals/SearchModal/components/ProductsGrid/ProductsGrid.tsx











var PRODUCT_BUTTON_PROPS = {
    metadata: {
        placement: "Search"
    }
};
var PRODUCTS_SKELETON = new Array(6).fill(null).map(function(value, index) {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductCardSmallSkeleton/* default */.Z, {}, index);
});
var ProductsGrid = function(props) {
    var products = props.products, isFetching = props.isFetching, className = props.className, query = props.query, dataTestId = props["data-testid"];
    var isMobile = (0,useDevice/* default */.Z)().isMobile;
    var columns = isMobile ? "2-center" : "6-center";
    var createOnItemClick = function(product) {
        return function() {
            var _product_rating, _product_tradingItems_items_, _product_tradingItems_items, _product_tradingItems;
            var params = {
                query: query,
                productBrand: product.brandInfo.name,
                productCategory: product.category,
                productFullName: product.fullName,
                productGender: product.gender,
                productId: product.id,
                rating: (_product_rating = product.rating) === null || _product_rating === void 0 ? void 0 : _product_rating.avgRate
            };
            if ((_product_tradingItems = product.tradingItems) === null || _product_tradingItems === void 0 ? void 0 : (_product_tradingItems_items = _product_tradingItems.items) === null || _product_tradingItems_items === void 0 ? void 0 : (_product_tradingItems_items_ = _product_tradingItems_items[0]) === null || _product_tradingItems_items_ === void 0 ? void 0 : _product_tradingItems_items_.volume) {
                var _product_tradingItems_items__volume = product.tradingItems.items[0].volume, volume = _product_tradingItems_items__volume.volume, unit = _product_tradingItems_items__volume.unit;
                params.productVolume = "".concat(volume, " ").concat(unit);
            }
            (0,analytics/* track */.j)("Search product name click", params);
        };
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
        className: className,
        align: "stretch",
        columns: columns,
        gutter: 16,
        "data-testid": dataTestId,
        children: isFetching ? PRODUCTS_SKELETON : products.map(function(product) {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP.Cell, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductCardSmall/* default */.Z, {
                    data: product,
                    className: "h-full",
                    buttonProps: PRODUCT_BUTTON_PROPS,
                    onProductClick: createOnItemClick(product)
                })
            }, product.id);
        })
    });
};
/* harmony default export */ const ProductsGrid_ProductsGrid = (ProductsGrid);

// EXTERNAL MODULE: ./src/modules/products/useCatalogueId.ts + 2 modules
var useCatalogueId = __webpack_require__(7362);
// EXTERNAL MODULE: ./src/modules/products/useCatalogueProducts.ts + 1 modules
var useCatalogueProducts = __webpack_require__(69219);
;// CONCATENATED MODULE: ./src/compositions/modals/SearchModal/util/useTopRatedProducts.ts

var useTopRatedProducts = function(param) {
    var gender = param.gender;
    var catalogueName = gender === "MALE" ? "colognes" : "perfumes";
    var _useCatalogueId = (0,useCatalogueId/* default */.Z)({
        catalogueName: catalogueName
    }), catalogueId = _useCatalogueId.catalogueId, isFetchingCatalogue = _useCatalogueId.isFetching;
    var _useCatalogueProducts = (0,useCatalogueProducts/* default */.Z)({
        variables: {
            id: catalogueId,
            input: {
                limit: 6,
                sort: "RATING_DESC"
            }
        },
        ssr: false,
        skip: !catalogueId
    }), data = _useCatalogueProducts.data, isFetching = _useCatalogueProducts.isFetching;
    return {
        isFetching: isFetchingCatalogue || isFetching,
        products: data === null || data === void 0 ? void 0 : data.products
    };
};

// EXTERNAL MODULE: ./src/helpers/modifiers/formatPrice.ts
var formatPrice = __webpack_require__(72160);
// EXTERNAL MODULE: ./src/components/dataDisplay/Image/Image.tsx + 1 modules
var Image = __webpack_require__(85808);
// EXTERNAL MODULE: ./src/components/dataDisplay/BackgroundImage/BackgroundImage.tsx + 1 modules
var BackgroundImage = __webpack_require__(26713);
// EXTERNAL MODULE: ./src/components/layout/WidthContainerCompensator/WidthContainerCompensator.tsx
var WidthContainerCompensator = __webpack_require__(34626);
// EXTERNAL MODULE: ./src/compositions/buttons/CandleClubSubscribeButton/CandleClubSubscribeButton.tsx
var CandleClubSubscribeButton = __webpack_require__(48106);
;// CONCATENATED MODULE: ./src/compositions/banners/CandleSubscribeSmallBanner/messages.ts
/* harmony default export */ const CandleSubscribeSmallBanner_messages = ({
    supTitle: {
        en: "Candle Club"
    },
    title: {
        en: "Treat yourself to a new scented candle every month!"
    },
    text: {
        en: "Subscribe now, and get a luxe, hand-selected candle delivered to your door each month for {price}."
    },
    buttonTitle: {
        en: "Upgrade for just {price}"
    }
});

;// CONCATENATED MODULE: ./src/compositions/banners/CandleSubscribeSmallBanner/images/bg-desktop.jpg
const bg_desktop_namespaceObject = __webpack_require__.p + "images/bg-desktop_a79560.jpg";
;// CONCATENATED MODULE: ./src/compositions/banners/CandleSubscribeSmallBanner/images/bg-mobile.jpg
const bg_mobile_namespaceObject = __webpack_require__.p + "images/bg-mobile_8f143f.jpg";
;// CONCATENATED MODULE: ./src/compositions/banners/CandleSubscribeSmallBanner/images/bg-mobile.jpg?src-loader&size

/* harmony default export */ const bg_mobilesrc_loader_size = ({ src: bg_mobile_namespaceObject, aspect: 1.5127272727272727, width: 1248, height: 825 });
;// CONCATENATED MODULE: ./src/compositions/banners/CandleSubscribeSmallBanner/CandleSubscribeSmallBanner.tsx
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}











var CandleSubscribeSmallBanner = function(props) {
    var className = props.className, placement = props.placement, withMobileCompensator = props.withMobileCompensator, dataTestId = props["data-testid"];
    var isMobile = (0,useDevice/* default */.Z)().isMobile;
    var candleSubscription = (0,subscriptionAddons/* useCandleSubscription */.pj)().candleSubscription;
    var price = (candleSubscription === null || candleSubscription === void 0 ? void 0 : candleSubscription.price) || 2500;
    var priceWithCents = (0,formatPrice/* default */.Z)(price);
    var priceWithoutCents = (0,formatPrice/* default */.Z)(price, {
        removeZeroCents: true
    });
    var content = /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: isMobile ? "bg-black px-40 pt-40 pb-48" : "w-6/12 pb-4 text-left",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.ZP, {
                message: CandleSubscribeSmallBanner_messages.supTitle,
                style: "eye2",
                color: "gold-30"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.ZP, {
                className: "mt-16",
                message: CandleSubscribeSmallBanner_messages.title,
                style: isMobile ? "h5" : "h7",
                color: "white"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.ZP, {
                className: "mt-16",
                message: _object_spread_props(_object_spread({}, CandleSubscribeSmallBanner_messages.text), {
                    values: {
                        price: priceWithoutCents
                    }
                }),
                style: isMobile ? "p1" : "p3",
                color: "white"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(CandleClubSubscribeButton/* default */.Z, {
                className: "mt-16",
                title: _object_spread_props(_object_spread({}, CandleSubscribeSmallBanner_messages.buttonTitle), {
                    values: {
                        price: priceWithCents
                    }
                }),
                placement: placement,
                size: isMobile ? 56 : 48,
                style: "gold-30",
                width: 240,
                fullWidth: true,
                "data-testid": "candleSubscriptionBanner"
            })
        ]
    });
    var Wrapper = isMobile && withMobileCompensator ? WidthContainerCompensator/* default */.Z : react.Fragment;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Wrapper, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: className,
            "data-testid": dataTestId,
            children: isMobile ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* default */.Z, _object_spread({
                        className: "w-full"
                    }, bg_mobilesrc_loader_size)),
                    content
                ]
            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(BackgroundImage/* default */.Z, {
                className: "flex flex-col items-start justify-center bg-black px-32",
                src: bg_desktop_namespaceObject,
                style: {
                    backgroundPosition: "0 50%",
                    height: "296rem"
                },
                children: content
            })
        })
    });
};
/* harmony default export */ const CandleSubscribeSmallBanner_CandleSubscribeSmallBanner = (CandleSubscribeSmallBanner);

;// CONCATENATED MODULE: ./src/compositions/modals/SearchModal/components/TopRatedProducts/TopRatedProducts.tsx












var TopRatedProducts = function(props) {
    var className = props.className, title = props.title, withBanner = props.withBanner;
    var gender = (0,user/* useUser */.a)().gender;
    var isMobile = (0,useDevice/* default */.Z)().isMobile;
    var _useTopRatedProducts = useTopRatedProducts({
        gender: gender
    }), products = _useTopRatedProducts.products, isFetchingProducts = _useTopRatedProducts.isFetching;
    var _useCandleSubscription = (0,subscriptionAddons/* useCandleSubscription */.pj)(), candleSubscription = _useCandleSubscription.candleSubscription, isCandleSubscriptionFetching = _useCandleSubscription.isFetching;
    var isFetching = isFetchingProducts || isCandleSubscriptionFetching;
    var isBannerVisible = withBanner && !isFetching && (candleSubscription === null || candleSubscription === void 0 ? void 0 : candleSubscription.isEnabled) && !(candleSubscription === null || candleSubscription === void 0 ? void 0 : candleSubscription.isSelected);
    if (!isFetching && !(products === null || products === void 0 ? void 0 : products.length)) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.ZP, {
            className: (0,clsx/* default */.Z)(isMobile ? "mt-20" : "mt-36", {
                "text-center": !isMobile
            }),
            style: "p2",
            message: messages.somethingWrong,
            "data-testid": "somethingWrong"
        });
    }
    if (isBannerVisible) {
        var firstProducts = products.slice(0, 4);
        var secondProducts = products.slice(4);
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
            children: [
                title,
                /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductsGrid_ProductsGrid, {
                    className: className,
                    query: "",
                    products: firstProducts,
                    "data-testid": "topRatedProducts"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(CandleSubscribeSmallBanner_CandleSubscribeSmallBanner, {
                    className: "my-32",
                    placement: "Search"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductsGrid_ProductsGrid, {
                    query: "",
                    products: secondProducts,
                    "data-testid": "topRatedProducts2"
                })
            ]
        });
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            title,
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductsGrid_ProductsGrid, {
                className: className,
                query: "",
                products: products,
                isFetching: isFetching,
                "data-testid": "topRatedProducts"
            })
        ]
    });
};
/* harmony default export */ const TopRatedProducts_TopRatedProducts = (TopRatedProducts);

// EXTERNAL MODULE: ./src/components/inputs/ActionButton/ActionButton.tsx
var ActionButton = __webpack_require__(79230);
// EXTERNAL MODULE: ./src/modules/brands/useStrapiWSTONavigationData.ts
var useStrapiWSTONavigationData = __webpack_require__(14159);
// EXTERNAL MODULE: ./src/compositions/banners/TheEditBanner/TheEditBanner.tsx + 2 modules
var TheEditBanner = __webpack_require__(47866);
// EXTERNAL MODULE: ./src/compositions/Header/view/Desktop/components/banners/StrapiWSTONavigationBanner/StrapiWSTONavigationBanner.tsx
var StrapiWSTONavigationBanner = __webpack_require__(98539);
// EXTERNAL MODULE: ./local_modules/links/index.ts + 4 modules
var links = __webpack_require__(69541);
// EXTERNAL MODULE: ./src/components/navigation/Href/Href.tsx
var Href = __webpack_require__(73358);
// EXTERNAL MODULE: ./src/components/inputs/Button/Button.tsx + 6 modules
var Button = __webpack_require__(23796);
;// CONCATENATED MODULE: ./src/compositions/modals/SearchModal/components/Banner/components/CleanFragrancesBanner/messages.ts
/* harmony default export */ const CleanFragrancesBanner_messages = ({
    title: {
        en: "The scents you want,\nminus the ingredients\nyou don't"
    },
    text: {
        en: "These clean fragrances are\nintoxicating to the senses, but\nuse completely non-toxic\nformulations."
    },
    buttonTitle: {
        en: "Shop clean scents"
    }
});

;// CONCATENATED MODULE: ./src/compositions/modals/SearchModal/components/Banner/components/CleanFragrancesBanner/images/bg.jpg
const bg_namespaceObject = __webpack_require__.p + "images/bg_98cb64.jpg";
;// CONCATENATED MODULE: ./src/compositions/modals/SearchModal/components/Banner/components/CleanFragrancesBanner/CleanFragrancesBanner.tsx










var TRACK_CLEAN_FRAGRANCES_BANNER_CLICK = function() {
    (0,analytics/* track */.j)("Banner click", {
        placement: "Search",
        content: "Clean fragrances",
        link: links/* default */.ZP.clean.perfumes,
        action: "link"
    });
};
var CleanFragrancesBanner = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Href/* default */.Z, {
        to: links/* default */.ZP.clean.perfumes,
        "data-testid": "searchBanner",
        onClick: TRACK_CLEAN_FRAGRANCES_BANNER_CLICK,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(BackgroundImage/* default */.Z, {
            className: (0,clsx/* default */.Z)("bg-gray-70 p-32"),
            src: bg_namespaceObject,
            style: {
                backgroundPosition: "0 50%",
                height: "296rem"
            },
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.ZP, {
                    className: "whitespace-pre-line",
                    style: "h7",
                    message: CleanFragrancesBanner_messages.title
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.ZP, {
                    className: "mt-16 whitespace-pre-line",
                    style: "p3",
                    color: "white",
                    message: CleanFragrancesBanner_messages.text
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                    className: "mt-16",
                    title: CleanFragrancesBanner_messages.buttonTitle,
                    size: 48,
                    style: "primary",
                    tabIndex: -1,
                    width: 240
                })
            ]
        })
    });
};
/* harmony default export */ const CleanFragrancesBanner_CleanFragrancesBanner = (CleanFragrancesBanner);

;// CONCATENATED MODULE: ./src/compositions/modals/SearchModal/components/Banner/Banner.tsx











var Banner = function() {
    var _strapiWSTONavigationData_banners;
    var isTheEditEnabled = (0,useFt/* default */.Z)(constants/* default */.Z.features.theEdit);
    var strapiWSTONavigationData = (0,useStrapiWSTONavigationData/* default */.Z)();
    var isStrapiWSTONavigationSearchBannerExists = Boolean(strapiWSTONavigationData === null || strapiWSTONavigationData === void 0 ? void 0 : (_strapiWSTONavigationData_banners = strapiWSTONavigationData.banners) === null || _strapiWSTONavigationData_banners === void 0 ? void 0 : _strapiWSTONavigationData_banners.search);
    var isCandleSubscriptionSearchBannerEnabled = (0,useFt/* default */.Z)(constants/* default */.Z.features.candleClubMoreBanners);
    var _useCandleSubscription = (0,subscriptionAddons/* useCandleSubscription */.pj)({
        skip: isStrapiWSTONavigationSearchBannerExists
    }), candleSubscription = _useCandleSubscription.candleSubscription, isFetching = _useCandleSubscription.isFetching;
    if (isFetching) {
        return null;
    }
    var isCandleSubscriptionBannerVisible = isCandleSubscriptionSearchBannerEnabled && (candleSubscription === null || candleSubscription === void 0 ? void 0 : candleSubscription.isEnabled) && !candleSubscription.isSelected;
    if (isStrapiWSTONavigationSearchBannerExists) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(StrapiWSTONavigationBanner/* default */.Z, {
            placement: "search",
            "data-testid": "searchBanner"
        });
    }
    if (isCandleSubscriptionBannerVisible) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(CandleSubscribeSmallBanner_CandleSubscribeSmallBanner, {
            placement: "Search",
            "data-testid": "searchBanner",
            withMobileCompensator: true
        });
    }
    return isTheEditEnabled ? /*#__PURE__*/ (0,jsx_runtime.jsx)(TheEditBanner/* default */.Z, {
        placement: "Search",
        "data-testid": "searchBanner"
    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(CleanFragrancesBanner_CleanFragrancesBanner, {});
};
/* harmony default export */ const Banner_Banner = (Banner);

;// CONCATENATED MODULE: ./src/compositions/modals/SearchModal/components/Nav/util/messages.ts
/* harmony default export */ const util_messages = ({
    quiz: {
        title: {
            en: "Let’s get personal"
        },
        actionText: {
            en: "Take our fragrance quiz"
        }
    },
    collections: {
        title: {
            en: "Need some ideas?"
        },
        actionText: {
            en: "Browse our curated collections"
        }
    },
    home: {
        title: {
            en: "Cozy at home"
        },
        actionText: {
            en: "Our latest home fragrances"
        }
    },
    theEdit: {
        title: {
            en: "The Edit"
        },
        actionText: {
            en: "Explore home fragrances"
        }
    }
});

;// CONCATENATED MODULE: ./src/compositions/modals/SearchModal/components/Nav/util/data.ts
function data_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function data_object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            data_define_property(target, key, source[key]);
        });
    }
    return target;
}
function data_ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function data_object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        data_ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}


var defaultNavItems = [
    data_object_spread_props(data_object_spread({}, util_messages.quiz), {
        to: links/* default */.ZP.smartRecommendations,
        trackingKey: "Take our fragrance quiz"
    }),
    data_object_spread_props(data_object_spread({}, util_messages.collections), {
        MALE: {
            to: links/* default */.ZP.collectionsMen
        },
        FEMALE: {
            to: links/* default */.ZP.collectionsWomen
        },
        trackingKey: "Browse our curated collections"
    })
];
var bestsellersNavItems = [
    data_object_spread_props(data_object_spread({}, util_messages.home), {
        MALE: {
            to: links/* default */.ZP.bestsellers.colognes
        },
        FEMALE: {
            to: links/* default */.ZP.bestsellers.perfumes
        },
        trackingKey: "Our latest home fragrances"
    })
];
var theEditNavItems = [
    data_object_spread_props(data_object_spread({}, util_messages.theEdit), {
        to: links/* default */.ZP.shop.theEdit,
        trackingKey: "The edit"
    })
];

;// CONCATENATED MODULE: ./src/compositions/modals/SearchModal/components/Nav/util/useNav.ts
function useNav_array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function useNav_array_without_holes(arr) {
    if (Array.isArray(arr)) return useNav_array_like_to_array(arr);
}
function useNav_iterable_to_array(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function useNav_non_iterable_spread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function useNav_to_consumable_array(arr) {
    return useNav_array_without_holes(arr) || useNav_iterable_to_array(arr) || useNav_unsupported_iterable_to_array(arr) || useNav_non_iterable_spread();
}
function useNav_unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return useNav_array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return useNav_array_like_to_array(o, minLen);
}





var useNav = function() {
    var isTheEditEnabled = (0,useFt/* default */.Z)(constants/* default */.Z.features.theEdit);
    return (0,react.useMemo)(function() {
        var extraNavItems = isTheEditEnabled ? theEditNavItems : bestsellersNavItems;
        return useNav_to_consumable_array(defaultNavItems).concat(useNav_to_consumable_array(extraNavItems));
    }, [
        isTheEditEnabled
    ]);
};
/* harmony default export */ const util_useNav = (useNav);

;// CONCATENATED MODULE: ./src/compositions/modals/SearchModal/components/Nav/Nav.tsx
function Nav_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function Nav_object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            Nav_define_property(target, key, source[key]);
        });
    }
    return target;
}










var Nav = function(props) {
    var gender = (0,user/* useUser */.a)().gender;
    var className = props.className;
    var navItems = util_useNav();
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (0,clsx/* default */.Z)(className, "flex w-full items-start self-center"),
        "data-testid": "nav",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "w-6/12 pr-8",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Banner_Banner, {})
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                className: "w-6/12 self-center pl-72",
                children: navItems.map(function(item, index) {
                    var _$_object_spread = Nav_object_spread({}, item, item[gender]), title = _$_object_spread.title, actionText = _$_object_spread.actionText, to = _$_object_spread.to, trackingKey = _$_object_spread.trackingKey;
                    var trackLinkClick = function() {
                        (0,analytics/* track */.j)("Search explore link click", {
                            content: trackingKey,
                            link: to
                        });
                    };
                    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                        className: (0,clsx/* default */.Z)("mr-16 w-full", {
                            "mt-48": index
                        }),
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.ZP, {
                                style: "p1",
                                message: title
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(ActionButton/* default */.Z, {
                                className: "mt-8",
                                title: actionText,
                                to: to,
                                onClick: trackLinkClick
                            })
                        ]
                    }, to);
                })
            })
        ]
    });
};
/* harmony default export */ const Nav_Nav = (Nav);

;// CONCATENATED MODULE: ./src/compositions/modals/SearchModal/SearchModal.module.css
// extracted by mini-css-extract-plugin
/* harmony default export */ const SearchModal_module = ({"header":"cILhXK","logo":"d3BJLF","searchInput":"mLE9TE","closeButton":"kpJpJp"});
;// CONCATENATED MODULE: ./src/compositions/modals/SearchModal/SearchModal.tsx


















var SearchModal = function(props) {
    var name = props.name, closeModal = props.closeModal;
    var handleCloseButtonClick = function() {
        return closeModal(true);
    };
    var isCandleClubMoreBannersEnabled = (0,useFt/* default */.Z)(constants/* default */.Z.features.candleClubMoreBanners);
    var isMobile = (0,useDevice/* default */.Z)().isMobile;
    var _useSearchModal = useSearchModal(), form = _useSearchModal.form, query = _useSearchModal.query, products = _useSearchModal.products, isFetching = _useSearchModal.isFetching, error = _useSearchModal.error;
    var content;
    if (error) {
        // TODO: "Server error" UI element
        content = error.message;
    } else if (!query) {
        content = isMobile ? /*#__PURE__*/ (0,jsx_runtime.jsx)(TopRatedProducts_TopRatedProducts, {
            className: "pt-32",
            withBanner: isCandleClubMoreBannersEnabled,
            title: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.ZP, {
                className: "mt-48",
                style: "h5",
                message: messages.topRatedTitle,
                "data-testid": "topRatedLabel"
            })
        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(Nav_Nav, {
            className: "mt-36"
        });
    } else if (query.length <= 2 || !isFetching && !(products === null || products === void 0 ? void 0 : products.length)) {
        /* User see "not found" text with default recommendations of the first fragrances from Top Rated Products */ content = /*#__PURE__*/ (0,jsx_runtime.jsx)(TopRatedProducts_TopRatedProducts, {
            className: isMobile ? "pt-24" : "pt-32",
            withBanner: isMobile && isCandleClubMoreBannersEnabled,
            title: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.ZP, {
                className: (0,clsx/* default */.Z)(isMobile ? "mt-20" : "mt-36", {
                    "text-center": !isMobile
                }),
                style: "p2",
                message: messages.notFound,
                "data-testid": "notFoundBlock"
            })
        });
    } else {
        content = /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductsGrid_ProductsGrid, {
            className: isMobile ? "pt-32" : "pt-36",
            products: products,
            isFetching: isFetching,
            "data-testid": "searchProducts",
            query: query
        });
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(PlainModal/* default */.ZP, {
        type: "fullscreen-top",
        withCloseButton: false,
        underMobileHeader: false,
        closeModal: closeModal,
        "data-testid": name,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(WidthContainer/* default */.Z, {
            className: "w-full",
            ignore: isMobile,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: (0,clsx/* default */.Z)(SearchModal_module.header, "relative grid"),
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(LogoLink/* default */.Z, {
                            className: SearchModal_module.logo,
                            color: "black"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(SearchInput/* default */.Z, {
                            className: SearchModal_module.searchInput,
                            size: isMobile ? 30 : 34,
                            field: form.fields.search,
                            placeholder: messages.placeholder
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(CloseIconButton/* default */.Z, {
                            className: SearchModal_module.closeButton,
                            onClick: handleCloseButtonClick
                        })
                    ]
                }),
                content
            ]
        })
    });
};
/* harmony default export */ const SearchModal_SearchModal = (SearchModal);


/***/ })

}]);